const state = {
  memberships: [],
};

const getters = {
  /**
   * Return all the external memberships of the current user
   * @returns {Array}
   */
  getExternalMemberships(state) {
    return state.memberships;
  },

  /**
   * Returns the external membership of the current user with the provided project
   * @param {String} hash
   * @returns {Object} The external membership
   */
  getExternalMembership(state) {
    return hash =>
      state.memberships.find(membership => membership.project_hash === hash);
  },

  /**
   * Returns if the current user is an external member of the current workspace
   * @returns {Boolean}
   */
  isInCurrentWorkspace(state, getters, rootState, rootGetters) {
    const currentWorkspaceId = rootGetters['workspace/getId'];
    return !!state.memberships.find(
      membership => membership.workspace_id === currentWorkspaceId
    );
  },

  /**
   * Returns if the current user is a member of the provided project
   * @param {String} hash
   * @returns {Boolean}
   */
  isInProject(state, getters) {
    return hash => !!getters.getExternalMembership(hash);
  },

  /**
   * Returns the external member role of the current user to the provided project
   * @param {String} hash
   * @returns {String}
   */
  getExternalRole(state, getters) {
    return hash => getters.getExternalMembership(hash)?.role;
  },

  /**
   * Returns the external member role of the current user to the current project
   * @returns {String|null}
   */
  getCurrentProjectRole(state, getters, rootState, rootGetters) {
    const currentProjectHash = rootGetters['project/getHash'];

    return getters.getExternalRole(currentProjectHash) || null;
  },
};

const actions = {
  /**
   * Sets the external memberships of the current user
   * @param {Array} value
   */
  setExternalMemberships(context, { value }) {
    context.commit('setExternalMemberships', { value });
  },
};

const mutations = {
  /**
   * Sets the external memberships of the current user
   * @param {Array} value
   */
  setExternalMemberships(state, { value }) {
    state.memberships = value;
  },
};

const module = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default module;
